import { render, staticRenderFns } from "./error-close.vue?vue&type=template&id=32ae0f1a&"
import script from "./error-close.vue?vue&type=script&lang=js&"
export * from "./error-close.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32ae0f1a')) {
      api.createRecord('32ae0f1a', component.options)
    } else {
      api.reload('32ae0f1a', component.options)
    }
    module.hot.accept("./error-close.vue?vue&type=template&id=32ae0f1a&", function () {
      api.rerender('32ae0f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/error-close.vue"
export default component.exports